import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import useDisplay from "../../hooks/useDisplay";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgH2HeadLine from "./../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSRgBody01 from "./../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import { consultingTabList } from "../../constant/consultingTabList";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import PretendardText from "../../components/atoms/text/pretendardText";
import MontserratText from "../../components/atoms/text/montserratText";
import LSBdDisplay01 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay01";
import LSRgBody02 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody02";
import LSBdDisplay03 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay03";
import LSBdCaption02 from "../../components/molecules/text/linSeedKr/Bd/lsBdCaption02";
import ReviewSwiper from "./../../components/templates/home/reviewSwiper";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "./../../components/organisms/SelectBox";
import LSBdBody02 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody02";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import LSRgCaption03 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption03";
import ReviewItem from "../../components/organisms/review/reviewItem";
import Empty from "../../components/molecules/empty";
import ReviewApi from "../../api/review.api";
import { errorHandler } from "../../util/errorHandler";
import { toast } from "react-toastify";
import { route } from "../../router/route";
import LectureApi from "../../api/lecture.api";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";

const Consulting = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(
    consultingTabList[0].title,
  );

  const [reviewList, setReviewList] = useState([]);
  const [consultingTab, setIsConsultingTab] = useState([]);

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") === "true") {
      reviewListFunc();
      consultingListFunc();
    } else {
      toast("로그인을 해주세요.");
      navigate(`${route.login}`, {
        state: { path: window.location.href },
      });
    }
  }, []);

  const consultingListFunc = async () => {
    try {
      const data = {
        page: 1,
        size: 1,
        lectureVideoFlag: "Inactive",
      };
      const response = (await LectureApi.getMemberList(data)).data.data.content;

      if (response && response.length > 0) {
        setIsConsultingTab(consultingTabList);
      } else {
        setIsConsultingTab([
          { title: "1:1 컨설팅이란?", path: route.consulting },
          { title: "사전 상담 받기", path: route.consulting_prior },
          { title: "신청하기", path: route.consulting_apply },
        ]);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const reviewListFunc = async () => {
    try {
      const data = {
        page: 1,
        size: 6,
        activation: "Active",
        mainFlag: "Active",
        lectureType: "Merch",
      };
      const response = (await ReviewApi.getList(data)).data.data.content;

      setReviewList(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const differenceBoxList = [
    {
      title: "정보의 불균형",
      content: (
        <>
          갈수록 쌓이는 대출규제로 인해
          <br />
          세금과 같이 전문가의 도움 없이는
          <br />
          수백, 수천만원을 놓칠 수 있습니다.
          <br />
          <br />
          내가 모르는 대출,
          <br />
          핀라이브는 그 정보들을
          <br />
          모두 알려드릴 수 있습니다.
        </>
      ),
    },
    {
      title: "대출조건은 사람이 결정한다",
      content: (
        <>
          어떤 자료를 적용하고, 해석을 했는지
          <br />
          상담은 어떤 방식으로 이루어 졌는지에
          <br />
          따라 대출 조건과 한도가 달라집니다.
          <br />
          <br />
          200건이 넘는 컨설팅 경험을 가진
          <br />
          핀라이브는 최선의 조건을
          <br />
          어떻게든 찾아냅니다.
        </>
      ),
    },
    {
      title: "정보의 불균형",
      content: (
        <>
          A생명 보험사 직원은 A생명 보험을
          <br />
          추천하고, B생명 보험은 알지도 못합니다. 대출도 마찬가지입니다.
          <br />타 대출과의 차이를 비교하지 못합니다.
          <br />
          <br />
          상호금융, 저축은행, 보험회사의 경험으로 직접 비교할 수 있습니다.
        </>
      ),
    },
  ];

  const chapter01ContentTextList = [
    <>
      받은 대출이
      <br />
      괜찮은 조건인지 아닌지 판단
    </>,
    <>
      세입자에게 내어줘야 하는
      <br />
      보증금을 만드는 법
    </>,
    <>
      현 상황에서 가장 합리적인 대출이
      <br />
      어떤 것인지 파악
    </>,
    <>
      도저히 불가능할 것 같은
      <br />
      자금을 대출받는 법
    </>,
    <>믿을만한 전문가의 확실한 대답</>,
    <>복잡한 정부지원 대출을 받는 방법</>,
    <>
      신용불량위기에 처했을 때
      <br />
      구제받는 법
    </>,
    <>필요한 부분에 대한 대출 과외</>,
    <>그 외 자금관련 모든 고충</>,
  ];

  const chapter02ContentList = [
    {
      circleColor: "rgba(219, 221, 224, 1)",
      title: "사전상담 신청하기",
      content: (
        <>
          상담 내용을 확인하고,
          <br />
          적합한 컨설팅 상품을 추천해 드립니다.
        </>
      ),
    },
    {
      circleColor: "rgba(164, 168, 177, 0.8)",
      title: "1:1 컨설팅 신청하기",
      content: (
        <>
          [신청하기] 페이지에서 추천해 드린
          <br />
          컨설팅 상품을 구매해 주세요.
        </>
      ),
    },
    {
      circleColor: "rgba(137, 142, 153, 0.8)",
      title: "필요 서류 제출",
      content: (
        <>
          구매 이후 [진행 중인 컨설팅] 에서
          <br />
          필요 서류를 제출해 주세요.
        </>
      ),
    },
    {
      circleColor: "rgba(111, 116, 128, 0.7)",
      title: "일정 확정 및 기타 안내",
      content: (
        <>
          전달 해주신 자료 기반으로
          <br />
          일정을 확정 후 안내를 해 드립니다.
        </>
      ),
    },
    {
      circleColor: "rgba(64, 66, 73, 0.7)",
      title: "1:1 컨설팅 진행",
      content: (
        <>
          구매하신 컨설팅에 따라
          <br />
          1:1 컨설팅을 진행합니다.
        </>
      ),
    },
    {
      circleColor: "rgba(40, 42, 46, 0.8)",
      title: "컨설팅 완료",
      content: (
        <>
          완료 이후 후기 작성 시 희망자에 한하여
          <br />
          ‘질의응답 50문 50답' 전자책을 드립니다.
        </>
      ),
    },
  ];

  const chapter03ContentTextList = [
    <>
      내집을 마련하기 전
      <br />
      최적의 조건으로
      <br />
      대출을 받고 싶은 분
    </>,
    <>
      복잡한 대출 때문에
      <br />
      다 포기하고 싶은
      <br />
      마음이 드는 분
    </>,
    <>
      보증금, 대출 등의 문제로
      <br />
      당장 내 집이
      <br />
      경매로 넘어갈 것 같은 분
    </>,
    <>
      대출부분은 아예
      <br />
      위임해버리고 싶은 분
    </>,
    <>
      대출에 대해
      <br />
      아무것도 몰라서
      <br />
      진도가 안나가는 분
    </>,
    <>
      대출관련 학습, 방법 등
      <br />
      1:1 지도를 받아보고
      <br />
      싶은 분
    </>,
    <>
      하루한보의
      <br />
      상담 노하우를
      <br />
      알고 싶은 대출 상담사
    </>,
  ];

  const noteList = [
    "유료 상담은 최상의 만족도와 결과를 위해 하루 1건만 진행합니다.",
    "사전상담 결과에 따라 반려 및 환불 처리가 될 수도 있습니다.",
    "추후 해당 서비스는 종료될 수 있습니다.",
    "사전상담 후 본 상담이 시작되면 환불이 불가합니다.",
    "단, 컨설턴트 귀책 사유로 상담을 통한 변화가 없을 시 협의하여 전액 환불해 드립니다.",
    "운영시간: 주말 및 공휴일, 평일 오후 6시 이전",
    "본 서비스는 상담 서비스로, 원칙적으로 대출모집인이나 금융기관을 연계하지 않습니다.",
    "단, 고객의 요청 시 소개가 가능하며 대출 접수와 신청은 본인 주도하에 진행해야 합니다.",
  ];

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
          }}
        >
          <LSRgDisplay02
            style={{
              marginBottom: 32,
            }}
          >
            📋 1:1 컨설팅
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {consultingTab.map((tab, index) => {
                return (
                  <StyledCategoryItem
                    key={index}
                    onClick={() => navigate(tab.path)}
                    isActive={index === 0 ? true : false}
                    title={tab.title}
                  />
                );
              })}
            </TabContainer>
            {/* 본문 영역 */}
            <ContentContainer $isSmall={isSmall}>
              <ContentHeaderWrapper>
                <LSRgDisplay02 style={{ color: "#101113" }}>
                  1:1 컨설팅이란?
                </LSRgDisplay02>
              </ContentHeaderWrapper>

              <ContentBodyWrapper>
                <ContentTopImageWrapper
                  style={{
                    marginBottom: 50,
                  }}
                >
                  <img
                    src="/assets/images/consulting01.png"
                    style={{
                      width: 628,
                      height: 191,
                    }}
                    alt="답답한 경험"
                  />
                </ContentTopImageWrapper>

                <ContentTextWrapper
                  style={{
                    gap: 11,
                  }}
                >
                  <LSBdH2HeadLine>
                    이런 답답한 경혐 해본적 있으시죠?
                  </LSBdH2HeadLine>
                  <LSRgH1HeadLine
                    style={{
                      textAlign: "center",
                    }}
                  >
                    그럼 잘 찾아오셨습니다.
                    <br />
                    당신만을 위한 대출상담 창구입니다.
                  </LSRgH1HeadLine>
                </ContentTextWrapper>

                <ContentTopCircleWrapper>
                  <ContentTopCircle
                    style={{
                      opacity: 0.2,
                    }}
                  />
                  <ContentTopCircle
                    style={{
                      opacity: 0.5,
                    }}
                  />
                  <ContentTopCircle
                    style={{
                      opacity: 1,
                    }}
                  />
                </ContentTopCircleWrapper>

                <ContentTopImageWrapper
                  style={{
                    marginBottom: 30,
                  }}
                >
                  <img
                    src="/assets/images/consulting02.png"
                    style={{
                      width: 742,
                      height: 387,
                    }}
                    alt="후기"
                  />
                </ContentTopImageWrapper>

                <ContentTextWrapper
                  style={{
                    position: "relative",
                  }}
                >
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    약 200건이 넘는 후기들,
                  </LSBdH1HeadLine>
                  <LSRgH1HeadLine style={{ color: "#101113" }}>
                    지금도 수많은 사람들이 컨설팅하며 수백만원 또는 수천만원까지
                    아끼고 계십니다.
                  </LSRgH1HeadLine>
                  <span
                    style={{
                      position: "absolute",
                      width: 156,
                      height: 16,
                      top: 6,
                      zIndex: -1,
                      backgroundColor: "#ededff",
                    }}
                  />
                </ContentTextWrapper>

                <span
                  style={{
                    width: 1,
                    height: 89,
                    backgroundColor: "#5050ff",
                    alignSelf: "center",
                    margin: "60px 0px 30px 0px",
                  }}
                />

                <ContentTextWrapper
                  style={{
                    position: "relative",
                    gap: 12,
                    marginBottom: 40,
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      width: 190,
                      height: 34,
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: -1,
                      filter: "blur(40px)",
                      backgroundColor: "#E3E3FF",
                    }}
                  />
                  <MontserratText
                    style={{
                      width: 204,
                      height: 56,
                      textAlign: "center",
                      fontWeight: 900,
                      fontSize: 40,
                      lineHeight: "56px",
                      letterSpacing: "-0.6px",
                      color: "#101113",
                      background:
                        "linear-gradient(240deg, rgba(160, 255, 255, 1), rgba(80, 80, 255, 1))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    WHY?
                  </MontserratText>
                  <LSRgH1HeadLine
                    style={{
                      textAlign: "center",
                    }}
                  >
                    대체 왜,
                    <br />
                    상담 전과 후가 차이나는 걸까요?
                  </LSRgH1HeadLine>
                </ContentTextWrapper>

                <DifferenceBoxContainer>
                  {differenceBoxList.map((box, index) => (
                    <DifferenceBoxWrapper key={index}>
                      <PretendardText
                        style={{
                          fontWeight: 600,
                          fontSize: 20,
                          lineHeight: "30px",
                          color: "#5050ff",
                        }}
                      >
                        0{index + 1}
                      </PretendardText>
                      <LSBdDisplay01 style={{ color: "#101113" }}>
                        {box.title}
                      </LSBdDisplay01>
                      <LSRgBody02 style={{ color: "#575B65" }}>
                        {box.content}
                      </LSRgBody02>
                    </DifferenceBoxWrapper>
                  ))}
                </DifferenceBoxContainer>

                <ContentTextWrapper
                  style={{
                    gap: 10,
                    marginBottom: 80,
                  }}
                >
                  <LSBdDisplay01 style={{ color: "#5050FF" }}>
                    위 세가지로 인한 차이는 치명적입니다.
                  </LSBdDisplay01>
                  <LSRgH1HeadLine
                    style={{
                      textAlign: "center",
                    }}
                  >
                    내 최적의 대출 조건이 무엇인지 알 수 있는 유일한 방법은
                    <br />
                    존재하는 모든 대출 상품을 비교해 보는 것입니다.
                    <br />
                    <br />
                    핀라이브에서 정보의 불균형을 깨고 전부 알려드리겠습니다.
                  </LSRgH1HeadLine>
                </ContentTextWrapper>

                <ProfileInfoContainer>
                  <ProfileBoxWrapper>
                    <Profile />
                  </ProfileBoxWrapper>
                  <ProfileInfoWrapper>
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                      }}
                    >
                      <LSRgH1HeadLine>멘토</LSRgH1HeadLine>
                      <LSBdDisplay03>하루한보</LSBdDisplay03>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <PretendardText
                        style={{
                          fontWeight: 400,
                          fontSize: 16,
                          lineHeight: "24px",
                          color: "#575b65",
                        }}
                      >
                        탄탄대로, 고액연봉, 신의직장 ··· ‘은행’을 때려친{" "}
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontWeight: 700,
                          fontSize: 16,
                          lineHeight: "24px",
                          color: "#575b65",
                        }}
                      >
                        뼈강사, 뼈설턴트
                      </PretendardText>
                    </div>
                    <Divider
                      style={{
                        margin: "50px 0px",
                      }}
                    />
                    <img
                      src="/assets/images/consulting04.png"
                      style={{
                        width: 393.8,
                        height: 229.07,
                      }}
                      alt="패스트캠퍼스 캡쳐본"
                    />
                    <LSRgH1HeadLine style={{ color: "#575b65", marginTop: 30 }}>
                      대출상담사나 대출모집인이 아닌, 은행출신
                      대출컨설턴트입니다.
                      <br />
                      국내 상위 교육업체 ‘패스트캠퍼스’의 대출강사 경험을
                      비롯하여
                      <br />매 회차 100명의 선착순 강의가 완판되고 있습니다.
                    </LSRgH1HeadLine>
                  </ProfileInfoWrapper>
                </ProfileInfoContainer>

                <ChapterContainer>
                  <ChapterTitle>어떤 것들을 상담하나요?</ChapterTitle>
                  <Divider
                    style={{
                      margin: "16px 0px 20px 0px",
                    }}
                  />
                  <LSRgH1HeadLine>
                    대출과 관련된 모든 것을 전부 상담하실 수 있습니다.
                  </LSRgH1HeadLine>
                  <ChapterContentWrapper>
                    {chapter01ContentTextList.map((text, index) => (
                      <Chapter01ContentBox key={index}>
                        <Chapter01ContentBoxText>
                          {text}
                        </Chapter01ContentBoxText>
                      </Chapter01ContentBox>
                    ))}
                  </ChapterContentWrapper>
                </ChapterContainer>

                <ChapterContainer
                  style={{
                    marginTop: 80,
                  }}
                >
                  <ChapterTitle>상담 방법</ChapterTitle>
                  <Divider
                    style={{
                      marginTop: 16,
                    }}
                  />
                  <ChapterContentWrapper>
                    {chapter02ContentList.map((content, index) => (
                      <Chapter02ContentBox key={index}>
                        <Chapter02NumberingCircle
                          style={{ backgroundColor: content.circleColor }}
                        >
                          <Chapter02NumberingText>
                            0{index + 1}
                          </Chapter02NumberingText>
                        </Chapter02NumberingCircle>
                        <LSBdH1HeadLine
                          style={{
                            color: "#101113",
                            margin: "6px 0px 17px 0px",
                          }}
                        >
                          {content.title}
                        </LSBdH1HeadLine>
                        <LSRgBody01
                          style={{ textAlign: "center", color: "#575B65" }}
                        >
                          {content.content}
                        </LSRgBody01>
                      </Chapter02ContentBox>
                    ))}
                  </ChapterContentWrapper>
                </ChapterContainer>

                <ChapterContainer
                  style={{
                    margin: "80px 0px",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <ChapterTitle>이런 분들에게 추천해요!</ChapterTitle>
                  <ChapterContentWrapper
                    style={{
                      width: 648,
                      rowGap: 10,
                      columnGap: 9,
                    }}
                  >
                    {chapter03ContentTextList.map((text, index) => (
                      <Chapter03ContentBox key={index}>
                        <LSRgH1HeadLine
                          style={{ textAlign: "center", color: "#000075" }}
                        >
                          {text}
                        </LSRgH1HeadLine>
                      </Chapter03ContentBox>
                    ))}
                  </ChapterContentWrapper>
                </ChapterContainer>

                <ChapterContainer
                  style={{
                    marginBottom: 111,
                  }}
                >
                  <ChapterTitle>기타 유의사항</ChapterTitle>
                  <Divider
                    style={{
                      margin: "16px 0px 25px 0px",
                    }}
                  />
                  <ul
                    style={{
                      color: "#6F7480",
                      listStyleType: "disc",
                      paddingLeft: 20,
                      margin: 0,
                    }}
                  >
                    {noteList.map((note, index) => (
                      <li key={index} style={{}}>
                        <LSRgBody02 style={{ color: "#6F7480" }}>
                          {note}
                        </LSRgBody02>
                      </li>
                    ))}
                  </ul>
                </ChapterContainer>

                <LSRgDisplay02
                  style={{
                    marginBottom: 30,
                  }}
                >
                  🕶 1:1 컨설팅 후기들을 모았어요
                </LSRgDisplay02>
                {reviewList.length > 0 ? (
                  <ReviewSwiper dataList={reviewList} />
                ) : (
                  <Empty title={"등록된 후기가 없습니다."} />
                )}
              </ContentBodyWrapper>
            </ContentContainer>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>📋 1:1 컨설팅</LSRgH1HeadLine>
              <SelectBox
                style={{
                  width: "100%",
                }}
                subMenuStyle={{
                  width: "100%",
                }}
                isSmall={true}
                isOpen={subMenuBoxOpen}
                isLink={true}
                selectedValue={selectedSubMenu}
                wrapperHandler={() => {
                  setSubMenuBoxOpen(!subMenuBoxOpen);
                }}
                itemList={consultingTab}
                selectedValueSetterFunc={setSelectedSubMenu}
              />
            </ContentHeaderWrapper>
            <LSRgH1HeadLine>1:1 컨설팅이란?</LSRgH1HeadLine>
            <ContentBodyWrapper $isSmall={isSmall}>
              <ContentTopImageWrapper $isSmall={isSmall}>
                <img
                  src="/assets/images/consulting01_m.png"
                  style={{
                    width: 235.86,
                    height: 319,
                  }}
                  alt="답답한 경험"
                />
              </ContentTopImageWrapper>

              <ContentTextWrapper
                style={{
                  gap: 10,
                }}
              >
                <LSBdH1HeadLine>
                  이런 답답한 경혐 해본적 있으시죠?
                </LSBdH1HeadLine>
                <LSRgBody01
                  style={{
                    textAlign: "center",
                  }}
                >
                  그럼 잘 찾아오셨습니다.
                  <br />
                  당신만을 위한 대출상담 창구입니다.
                </LSRgBody01>
              </ContentTextWrapper>
              <ContentTopCircleWrapper $isSmall={isSmall}>
                <ContentTopCircle
                  style={{
                    opacity: 0.2,
                  }}
                />
                <ContentTopCircle
                  style={{
                    opacity: 0.5,
                  }}
                />
                <ContentTopCircle
                  style={{
                    opacity: 1,
                  }}
                />
              </ContentTopCircleWrapper>

              <ContentTopImageWrapper
                $isSmall={isSmall}
                style={{
                  marginBottom: 40,
                }}
              >
                <img
                  src="/assets/images/consulting02_m.png"
                  style={{
                    width: 293,
                    height: 509,
                  }}
                  alt="후기"
                />
              </ContentTopImageWrapper>

              <ContentTextWrapper
                style={{
                  position: "relative",
                }}
              >
                <LSBdH1HeadLine style={{ color: "#101113" }}>
                  약 200건이 넘는 후기들,
                </LSBdH1HeadLine>
                <LSRgH1HeadLine
                  style={{ textAlign: "center", color: "#101113" }}
                >
                  지금도 수많은 사람들이 컨설팅하며
                  <br />
                  수백만원 또는 수천만원까지 아끼고 계십니다.
                </LSRgH1HeadLine>
                <span
                  style={{
                    position: "absolute",
                    width: 156,
                    height: 16,
                    top: 6,
                    zIndex: -1,
                    backgroundColor: "#ededff",
                  }}
                />
              </ContentTextWrapper>

              <span
                style={{
                  width: 1,
                  height: 89,
                  backgroundColor: "#5050ff",
                  alignSelf: "center",
                  margin: "30px 0px",
                }}
              />

              <ContentTextWrapper
                style={{
                  position: "relative",
                  gap: 12,
                  marginBottom: 60,
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    width: 190,
                    height: 34,
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: -1,
                    filter: "blur(40px)",
                    backgroundColor: "#E3E3FF",
                  }}
                />
                <MontserratText
                  style={{
                    width: 204,
                    height: 56,
                    textAlign: "center",
                    fontWeight: 900,
                    fontSize: 40,
                    lineHeight: "56px",
                    letterSpacing: "-0.6px",
                    color: "#101113",
                    background:
                      "linear-gradient(240deg, rgba(160, 255, 255, 1), rgba(80, 80, 255, 1))",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  WHY?
                </MontserratText>
                <LSRgH1HeadLine
                  style={{
                    textAlign: "center",
                  }}
                >
                  대체 왜,
                  <br />
                  상담 전과 후가 차이나는 걸까요?
                </LSRgH1HeadLine>
              </ContentTextWrapper>

              <DifferenceBoxContainer $isSmall={isSmall}>
                {differenceBoxList.map((box, index) => (
                  <DifferenceBoxWrapper key={index} $isSmall={isSmall}>
                    <LSBdH2HeadLine
                      style={{ marginBottom: 15, color: "#5050ff" }}
                    >
                      0{index + 1}
                    </LSBdH2HeadLine>
                    <LSBdH2HeadLine
                      style={{ marginBottom: 12, color: "#101113" }}
                    >
                      {box.title}
                    </LSBdH2HeadLine>
                    <LSRgBody01 style={{ color: "#575B65" }}>
                      {box.content}
                    </LSRgBody01>
                  </DifferenceBoxWrapper>
                ))}
              </DifferenceBoxContainer>

              <ContentTextWrapper
                style={{
                  gap: 10,
                  marginBottom: 80,
                }}
              >
                <LSBdDisplay01
                  style={{ textAlign: "center", color: "#5050FF" }}
                >
                  위 세가지로 인한 차이는
                  <br />
                  치명적입니다.
                </LSBdDisplay01>
                <LSRgBody01
                  style={{
                    textAlign: "center",
                  }}
                >
                  내 최적의 대출 조건이 무엇인지
                  <br />알 수 있는 유일한 방법은
                  <br />
                  존재하는 모든 대출 상품을 비교해 보는 것입니다.
                  <br />
                  <br />
                  핀라이브에서 정보의 불균형을 깨고
                  <br />
                  전부 알려드리겠습니다.
                </LSRgBody01>
              </ContentTextWrapper>

              <ProfileInfoContainer $isSmall={isSmall}>
                <LSBdBody02 style={{ color: "#898E99" }}>강사 소개</LSBdBody02>
                <Divider style={{ margin: "16px 0px" }} />
                <div
                  style={{
                    display: "flex",
                    width: 290,
                    alignItems: "flex-start",
                    gap: 20,
                  }}
                >
                  <Profile $isSmall={isSmall} />
                  <div
                    style={{
                      display: "flex",
                      width: 157,
                      padding: "10px 0px",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 8,
                    }}
                  >
                    <LSRgCaption02>멘토</LSRgCaption02>
                    <LSBdH1HeadLine>하루한보</LSBdH1HeadLine>
                    <LSRgCaption02 style={{ textAlign: "center" }}>
                      탄탄대로, 고액연봉, 신의직장 ···
                      <br />
                      ‘은행’을 때려친 뼈강사, 뼈설턴트
                    </LSRgCaption02>
                  </div>
                </div>
                <img
                  src="/assets/images/consulting04.png"
                  style={{
                    width: 290,
                    height: 168.686,
                    margin: "20px 0px 15px 0px",
                  }}
                  alt="패스트캠퍼스 캡쳐본"
                />
                <LSRgBody01 style={{ marginBottom: 50.31, color: "#575B65" }}>
                  대출상담사나 대출모집인이 아닌, 은행출신 대출컨설
                  <br />
                  턴트입니다. 국내 상위 교육업체 ‘패스트캠퍼스’의 대출
                  <br />
                  강사 경험을 비롯하여 매 회차 100명의 선착순 강의가
                  <br />
                  완판되고 있습니다.
                </LSRgBody01>
              </ProfileInfoContainer>

              <ChapterContainer $isSmall={isSmall}>
                <LSBdBody02 style={{ color: "#101113" }}>
                  어떤 것들을 상담하나요?
                </LSBdBody02>
                <Divider
                  style={{
                    margin: "16px 0px",
                  }}
                />
                <LSRgBody01>
                  대출과 관련된 모든 것을 전부 상담하실 수 있습니다.
                </LSRgBody01>
                <ChapterContentWrapperMobile
                  style={{
                    margin: "20px 0px 50px 0px",
                    gap: 12,
                  }}
                >
                  {chapter01ContentTextList.map((text, index) => (
                    <Chapter01ContentBox key={index} $isSmall={isSmall}>
                      <LSRgBody01
                        style={{ textAlign: "center", color: "#000075" }}
                      >
                        {text}
                      </LSRgBody01>
                    </Chapter01ContentBox>
                  ))}
                </ChapterContentWrapperMobile>
              </ChapterContainer>

              <ChapterContainer $isSmall={isSmall}>
                <LSBdBody02 style={{ color: "#101113" }}>상담 방법</LSBdBody02>
                <Divider
                  style={{
                    margin: "16px 0px 20px 0px",
                  }}
                />
                <ChapterContentWrapperMobile
                  style={{
                    margin: "20px 0px 50px 0px",
                    gap: 21,
                  }}
                >
                  {chapter02ContentList.map((content, index) => (
                    <Chapter02ContentBox key={index}>
                      <Chapter02NumberingCircle
                        style={{ backgroundColor: content.circleColor }}
                      >
                        <Chapter02NumberingText>
                          0{index + 1}
                        </Chapter02NumberingText>
                      </Chapter02NumberingCircle>
                      <LSBdH1HeadLine
                        style={{
                          color: "#101113",
                          margin: "6px 0px 17px 0px",
                        }}
                      >
                        {content.title}
                      </LSBdH1HeadLine>
                      <LSRgBody01
                        style={{ textAlign: "center", color: "#575B65" }}
                      >
                        {content.content}
                      </LSRgBody01>
                    </Chapter02ContentBox>
                  ))}
                </ChapterContentWrapperMobile>
              </ChapterContainer>

              <ChapterContainer $isSmall={isSmall}>
                <LSBdBody02 style={{ color: "#101113" }}>
                  이런 분들에게 추천해요!
                </LSBdBody02>
                <ChapterContentWrapperMobile
                  style={{
                    marginTop: 20,
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    flexWrap: "wrap",
                    gap: 10,
                  }}
                >
                  {chapter03ContentTextList.map((text, index) => (
                    <Chapter03ContentBox key={index} $isSmall={isSmall}>
                      <LSRgCaption03
                        style={{ textAlign: "center", color: "#000075" }}
                      >
                        {text}
                      </LSRgCaption03>
                    </Chapter03ContentBox>
                  ))}
                </ChapterContentWrapperMobile>
              </ChapterContainer>

              <ChapterContainer
                $isSmall={isSmall}
                style={{
                  marginTop: 50,
                }}
              >
                <LSBdBody02 style={{ color: "#101113" }}>
                  기타 유의사항
                </LSBdBody02>
                <Divider
                  style={{
                    margin: "16px 0px",
                  }}
                />
                <ul
                  style={{
                    color: "#6F7480",
                    listStyleType: "disc",
                    paddingLeft: 20,
                    margin: 0,
                  }}
                >
                  {noteList.map((note, index) => (
                    <li key={index} style={{}}>
                      <LSRgCaption02 style={{ color: "#6F7480" }}>
                        {note}
                      </LSRgCaption02>
                    </li>
                  ))}
                </ul>
              </ChapterContainer>

              <ChapterContainer
                $isSmall={isSmall}
                style={{
                  marginTop: 53,
                }}
              >
                <LSRgH1HeadLine
                  style={{
                    marginBottom: 16,
                  }}
                >
                  🕶 1:1 컨설팅 후기들을 모았어요
                </LSRgH1HeadLine>
                <OverflowXHidden>
                  {reviewList.length > 0 ? (
                    reviewList.map((item, index) => {
                      return <ReviewItem data={item} key={index} />;
                    })
                  ) : (
                    <Empty title={"등록된 후기가 없습니다."} />
                  )}
                </OverflowXHidden>
              </ChapterContainer>
            </ContentBodyWrapper>
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default Consulting;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => (props.$isSmall ? "0px" : "150px")};
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "16px" : "4px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const ContentBodyWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  height: fit-content;
  padding: ${(props) => (props.$isSmall ? "30px 0px" : "0px")};
  align-items: ${(props) => (props.$isSmall ? "center" : "flex-start")};
`;

const ContentTopImageWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: fit-content;
  margin-bottom: ${(props) => (props.$isSmall ? "30px" : "50px")};
`;

const ContentTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: fit-content;
`;

const ContentTopCircleWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 11px;
  width: 100%;
  height: fit-content;
  margin: ${(props) =>
    props.$isSmall ? "20px 0px 30px 0px" : "35px 0px 44px 0px"};
`;

const ContentTopCircle = styled.span.attrs((props) => {})`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #5050ff;
`;

const DifferenceBoxContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  align-items: center;
  justify-content: center;
  width: 100%;
  height: fit-content;
  gap: 20px;
  margin-bottom: ${(props) => (props.$isSmall ? "60px" : "40px")};
`;

const DifferenceBoxWrapper = styled.div.attrs((props) => {})`
  width: 290px;
  height: ${(props) => (props.$isSmall ? "294px" : "328px")};
  background-color: rgba(237, 237, 255, 0.27);
  border-radius: 15px;
  border: 1px solid #e3e3ff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${(props) => (props.$isSmall ? "0px" : "21px")};
  padding: 0px 32px;
`;

const ProfileInfoContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "290px" : "100%")};
  height: fit-content;
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  gap: ${(props) => (props.$isSmall ? "0px" : "30px")};
  margin-bottom: ${(props) => (props.$isSmall ? "50px" : "20px")};
`;

const ProfileBoxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 380px;
  height: 380px;
`;

const Profile = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "100px" : "300px")};
  height: ${(props) => (props.$isSmall ? "100px" : "300px")};
  border-radius: 50%;
  background-image: url("/assets/images/profile.jpg");
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
`;

const ProfileInfoWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  padding: 50px 0px;
`;

const Divider = styled.span.attrs((props) => {})`
  width: 100%;
  height: 1px;
  background-color: #dbdde0;
`;

const ChapterTitle = styled(LSBdDisplay01)`
  color: #101113;
`;

const ChapterContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "290px" : "100%")};
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.$isSmall ? "0px" : "0px 40px")};
`;

const ChapterContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-wrap: wrap;
  row-gap: 20px;
  column-gap: 21px;
  width: 100%;
  margin-top: 25px;
`;

const ChapterContentWrapperMobile = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: fit-content;
`;

const Chapter01ContentBox = styled.div.attrs((props) => {})`
  width: 291px;
  height: ${(props) => (props.$isSmall ? "72px" : "120px")};
  background-color: rgba(237, 237, 255, 0.27);
  border-radius: 15px;
  border: 1px solid #e3e3ff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Chapter01ContentBoxText = styled(LSRgH1HeadLine)`
  color: #000075;
  text-align: center;
`;

const Chapter02ContentBox = styled.div.attrs((props) => {})`
  width: 291px;
  height: 175px;
  background-color: rgba(246, 247, 248, 0.3);
  border-radius: 15px;
  border: 1px solid #f6f7f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Chapter02NumberingCircle = styled.div.attrs((props) => {})`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Chapter02NumberingText = styled(LSBdCaption02)`
  color: #fff;
  margin-top: 2px;
`;

const Chapter03ContentBox = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "140px" : "210px")};
  height: ${(props) => (props.$isSmall ? "100px" : "150px")};
  background-color: rgba(237, 237, 255, 0.27);
  border-radius: 8px;
  border: 1px solid #e3e3ff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OverflowXHidden = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow-x: auto;
  width: 100%;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* 인터넷 익스플로러 */
  scrollbar-width: none; /* 파이어폭스 */
`;
